import { render } from "./Film.vue?vue&type=template&id=a6f4858e"
import script from "./Film.vue?vue&type=script&lang=js"
export * from "./Film.vue?vue&type=script&lang=js"
script.render = render

export default script